<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Nouveau participant
      </h2>
    </div>
    <div v-if="errorMessage" class="col-12 pt2 px2 white-bg flex flex-wrap justify-center red">
      <div class="col-12 p2 center">{{ errorMessage }} </div>
    </div>
    <div class="flex flex-wrap">
      <div class="col-12 white-bg p3 flex flex-wrap">
        <!-- GENDER ADD -->
        <div v-if="genderInput && genderInput.values" class="col-12 mx1 mb3 center flex justify-center flex-wrap">
          <div v-for="(type, index) in genderInput.values" :key="index" class="col-4" @click="selectGender(type.value)">
            <label class="pointer rounded px1" :for="type.id">
              <div :class="['avatar relative hover circle pointer overflow-hidden white mx-auto', { 'grey-bg': !isGenderSelected(type.value), 'light-blue-bg': isGenderSelected(type.value)}]">
                <i :class="['icon', type.icon]"></i>
              </div>
              <span class="h5 m1 bold block">{{ type.label }}</span>
            </label>
          </div>
        </div>

        <div v-for="(input, index) in inputs" :key="index" class="col-6 sm-col-12">
          <InputField
            v-if="!input.hideInput"
            :value="input.value"
            :name="input.name"
            :label="input.label"
            :type="input.type"
            :placeholder="input.placeholder"
            :pattern="input.pattern"
            :required="input.required"
            :props="input.props"
            @update:value="v => { input.value = v; }"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-6" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" class="col-4 sm-col-6 ml2" :disabled="!isFormValid" :action="handleCreateParticipant" text="Suivant" />
        <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import { addDays, format, isValid, isWithinInterval, parse, startOfDay, subYears } from 'date-fns';
import InputField from '@/components/participants/InputField.vue';
import Button from '@/components/elements/Button.vue';

import { createParticipant } from '@/utils/requests';
import { changeToPage } from '@/utils/logics';

export default {
  components: {
    InputField,
    Button
  },
  data () {
    return {
      loading: false,
      errorMessage: null,
      inputs: [
        { value: null, name: 'firstname', label: 'Prénom', type: 'text', required: true },
        { value: null, name: 'lastname', label: 'Nom de famille', type: 'text', required: true },
        { value: null, name: 'email', label: 'Email', type: 'email' },
        {
          value: null,
          name: 'birthdate',
          label: 'Date de naissance',
          type: 'date',
          placeholder: 'DD/MM/YYYY',
          required: true,
          rule: age => {
            if (!age) return false;
            const d = parse(age, 'dd/MM/yyyy', startOfDay(new Date()));
            return isValid(d) && isWithinInterval(d, { start: addDays(subYears(startOfDay(new Date()), 100), 1), end: startOfDay(new Date()) });
          },
          props: { minDate: addDays(subYears(startOfDay(new Date()), 100), 1) }
        },
        {
          value: null,
          name: 'gender',
          type: 'text',
          hideInput: true,
          required: true,
          values: [
            { label: 'Monsieur', id: 'male', value: 'mr', icon: 'icon-torso' },
            { label: 'Madame', id: 'female', value: 'mme', icon: 'icon-torso-female' }
            // { label: 'Mademoiselle', id: 'miss', value: 'miss', icon: 'icon-torso-female' }
          ]
        }
      ]
    };
  },
  computed: {
    genderInput () {
      return this.inputs.find(i => i.name === 'gender');
    },
    isFormValid () {
      return this.inputs.every(input => {
        if (input.required && !input.value) {
          return false;
        }
        if (input.hasOwnProperty('rule') && !input.rule(input.value)) {
          return false;
        }

        return true;
      });
    }
  },
  methods: {
    buildFormValues () {
      return this.inputs.reduce((acc, input) => {
        acc[input.name] = input.value;
        return acc;
      }, {});
    },
    changeToPage,
    isGenderSelected (value) {
      return this.genderInput.value === value;
    },
    selectGender (value) {
      this.genderInput.value = value;
    },
    handleBack () {
      this.changeToPage('AddParticipant');
    },
    async handleCreateParticipant () {
      this.errorMessage = null;
      if (!this.isFormValid) return;

      const body = this.buildFormValues();
      const birthRaw = body.birthdate;
      const birthParsed = birthRaw ? parse(birthRaw, 'dd/MM/yyyy', new Date()) : null;
      if (!isValid(birthParsed)) {
        this.errorMessage = 'Date de naissance invalide. Utilisez le format JJ/MM/AAAA (ex. 15/04/1990).';
        return;
      }

      this.loading = true;
      try {
        const res = await createParticipant({
          ...body,
          email: body.email || this.$store.state.user.email,
          birthdate: format(birthParsed, 'yyyy-MM-dd'),
          user: this.$store.state.user
        });

        if (res && res.loginUrl) return;

        const customer = res && res.customer;
        const code = res && res.code;
        if (res && res.message && !customer) {
          this.errorMessage = res.message;
          return;
        }
        if (customer) {
          this.$store.commit('setUser', customer);
          this.changeToPage('AddParticipant');
          return;
        }
        switch (code) {
          case 'ERROR_1':
            this.errorMessage = 'Veuillez utiliser des informations de contact différentes.';
            break;
          case 'ERROR_2':
            this.errorMessage = 'Si ce produit est pour vous, vous n’avez pas besoin de créer un participant. Veuillez choisir votre compte dans la liste en cliquant sur “précédent”.';
            break;
          default:
            this.errorMessage = 'Erreur inconnue. Veuillez contacter notre support.';
            break;
        }
      } catch (e) {
        this.errorMessage = 'La requête a échoué. Réessayez ou contactez le support.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .avatar {
    >.icon {
      position: absolute;
      font-size: 3rem;
      bottom: -0.3rem;
      left: 0;
      right: 0;
    }
  }
</style>
